import axios from "axios";
import api_requests from "../api/api_requests";

export default {
    state: {
        contents: null,
        test: 'test',
        plan_list:{},
        content: {},
        //active_plan_id:  0,
        //active_plan_id:  JSON.parse(localStorage.getItem('user')).subscription_id || 0,
        check_active_plan: false,
        max_available_plans: 0,
        end_trial: 0,
        trial_plan: []
    },
    mutations: {
        UPDATE_ACTIVE_PLAN(state, active_plan) {
            state.check_active_plan = active_plan
        },
        UPDATE_PLAN_LIST(state, plan_list) {
            state.plan_list = plan_list
        },
        UPDATE_ACTIVE_PLAN_ID(state, active_plan_id) {
            state.active_plan_id = active_plan_id
        },
        UPDATE_MAX_AVAILABLE_PLANS(state, max_available_plans) {
            state.max_available_plans = max_available_plans
        },
        UPDATE_END_TRIAL(state, end_trial) {
            state.end_trial = end_trial
        },
        UPDATE_TRIAL_PLAN(state, trial_plan) {
            state.trial_plan = trial_plan
        }
    },
    actions: {
        get_plans() {
            return new Promise ((resolve, reject) => {
                api_requests.get_plans().then((res) => {
                    resolve(res);
                })
            })
        },
        get_local_plans() {
          return new Promise ((resolve, reject) => {
              api_requests.get_local_plans().then((res) => {
                  resolve(res);
              })
          })
        },
        get_subscription_info() {
            return new Promise ((resolve, reject) => {
                api_requests.get_subscription_info({"client_id": JSON.parse(localStorage.getItem('user')).id})
                    .then((res) => {
                        console.log(res)
                        resolve(res);
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        update_info_subscription_after_pay() {
            return new Promise ((resolve) => {
                api_requests.update_info_subscription_after_pay()
                    .then(() => {
                        resolve()
                    })
            })
        },
        terminate_subscription() {
            return new Promise((resolve, reject)=>{
                api_requests.terminate_subscription({"subscription_id": JSON.parse(localStorage.getItem('user')).subscription_id})
                    .then((res) => {
                        console.log(res)
                        resolve(res)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        update_subscription_id(ctx, id) {
            ctx.commit('UPDATE_ACTIVE_PLAN_ID', id)
        },
        async checkActivePlan(ctx, page_owner) {   //checking the ACTIVE PLAN on the Project Page
           return await axios.post(
               process.env.VUE_APP_API+'/dashboard-integration/subscriptions', {"client_id": String(page_owner)},{
                   headers: {
                       'Authorization': localStorage.getItem('token')
                   }
               })
               .then((resp) => {
                   console.log(resp)
                   console.log('active plan')
                   let activePlan = resp.data.data.subscriptions.data.filter(val=>val.status === 'ACTIVE')
                   let answer = activePlan[0].workspace_plan_id

                   console.log(activePlan.length)
                   if (activePlan.length > 0) {
                       ctx.commit('UPDATE_ACTIVE_PLAN', true)
                   } else {
                       ctx.commit('UPDATE_ACTIVE_PLAN', false)
                   }

               })
               .catch(error => {
                   console.log(error);
               })
        },
        checkMaxPlans(ctx, page_owner) {
            axios.post(
                process.env.VUE_APP_API+'/dashboard-integration/subscriptions', {"client_id": String(page_owner)},{
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then((resp) => {
                    let activePlan = resp.data.data.subscriptions.data.filter(val=>val.status === 'ACTIVE')
                    let trialPlan = resp.data.data.subscriptions.data.filter(v=>v.workspace_plan_id === 5)
                    console.log('TRIALPLAN')
                    console.log(trialPlan.end_at === undefined)

                    axios.get(process.env.VUE_APP_API+'/dashboard-integration/plans', {
                        headers: {}
                    })
                        .then((resp) => {
                            console.log('ACTIVEPLAN')
                            console.log(activePlan.length)

                            //console.log(resp.data.data.plans.filter(v=>v.plan.id === activePlan[0].workspace_plan_id)[0].plan.id)
                            if (activePlan.length > 0) {
                                ctx.commit('UPDATE_MAX_AVAILABLE_PLANS', (resp.data.data.plans.filter(v=>v.plan.id === activePlan[0].workspace_plan_id)[0].rules.filter(r=>r.name==='Projects'))[0].default_limit)
                            } else {
                                ctx.commit('UPDATE_MAX_AVAILABLE_PLANS', 0)
                            }
                            if (activePlan.length > 0) {
                                //ctx.commit('UPDATE_ACTIVE_PLAN_ID', resp.data.data.plans.filter(v=>v.plan.id === activePlan[0].workspace_plan_id)[0].plan.id)
                            } else {
                                //ctx.commit('UPDATE_ACTIVE_PLAN_ID', 0)
                            }
                            console.log('trial plan here')
                            let trialPlan = resp.data.data.plans.filter(val=>val.plan.is_trial === 1)
                            console.log(trialPlan)
                            ctx.commit('UPDATE_PLAN_LIST', resp.data.data.plans)

                        })
                        .catch(error => {
                            //ctx.commit('UPDATE_ACTIVE_PLAN_ID', 0)
                            console.log(error);
                        })
                })
                .catch(error => {
                    console.log(error);
                })
        },
        async checkTrialPlan(ctx, page_owner) {
            axios.get(process.env.VUE_APP_API+'/dashboard-integration/plans', {
                headers: {}
            })
                .then((resp) => {
                    console.log(resp);
                    let trialPlanArr = resp.data.data.plans.filter(val=>val.plan.is_trial === 1)
                    let trialPlan = resp.data.data.plans.filter(val=>val.plan.is_trial === 1)[0]
                    let trialIntervalId = trialPlan.plan.id

                    if (trialPlanArr.length > 0) {
                        ctx.commit('UPDATE_TRIAL_PLAN',trialIntervalId)
                        axios.post(
                            process.env.VUE_APP_API+'/dashboard-integration/subscriptions', {"client_id": String(page_owner)},{
                                headers: {
                                    'Authorization': localStorage.getItem('token')
                                }
                            })
                            .then((resp) => {
                                let trialEndDate = Date.parse(resp.data.data.subscriptions.data.filter(v=>v.workspace_plan_id === trialIntervalId)[0].end_at)
                                console.log('subscription list for trial')
                                console.log(Date.parse(resp.data.data.subscriptions.data.filter(v=>v.workspace_plan_id === trialIntervalId)[0].end_at))
                                ctx.commit('UPDATE_END_TRIAL', trialEndDate)
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        }
    },
    getters: {
        getCheckingPlan(state) {
            return state.check_active_plan
        },
        getPlanList(state) {
            return state.plan_list
        },
        getActivePlanId(state) {
            return state.active_plan_id
        },
        getMaxAvailablePlans(state) {
            return state.max_available_plans
        },
        getEndTrial(state) {
            return state.end_trial
        },
        getTrialPlanPeriod(state) {
            return state.trial_plan
        }
    },
}
